import React from "react";
import SideBar from "./sidebar";
import { useNavigate, useLocation } from "react-router-dom";

const PrivateTemplateBusiness = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const role = localStorage.getItem("role");
  const splitted = pathname.split("/");
  const getRouteGroupLocation = splitted[1];
  React.useEffect(() => {
    const tokenExist = localStorage.getItem("access_token");
    if (!tokenExist) navigate("/login/business");
    if (role !== "business" && getRouteGroupLocation === "business") {
      navigate("/forbidden");
    }
  // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="h-screen w-full flex overflow-hidden">
        <SideBar />
        <main className="w-full h-full px-6 fixed-top overflow-y-scroll ">
          {children}
        </main>
      </div>
      );
    </>
  );
};

export default PrivateTemplateBusiness;
